import { Box, Typography, useTheme } from '@mui/material'
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import Logo from '../../assets/images/logo/vms-pro-logo.svg';
import React from 'react'
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import AdminDashboardHome from './Components/AdminDashboardHome';
import ClientDashboardHome from './Components/ClientDashboardHome';

function Dashboard() {
    const theme = useTheme();
    const { accountType } = useSelector((state) => state.user);
    const isClient = accountType === 'client' || accountType === 'Client';

    return (
        <Box sx={{ width: '100%', bgcolor: theme.palette.background.default, minHeight: '100vh', p: { xs: 0, md: 2 } }}>
            {/* عنوان لوحة التحكم */}
            <Box sx={{ display: 'flex', justifyContent: "space-between", gap: 2, mb: 3, mt: { xs: 2, md: 0 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3, mt: { xs: 2, md: 0 } }}>
                    <DashboardCustomizeOutlinedIcon sx={{ color: theme.palette.primary.main, fontSize: 36 }} />
                    <Typography variant="h4" sx={{ color: theme.palette.primary.main, fontWeight: 800, letterSpacing: 1 }}>
                        {t('Dashboard')}
                    </Typography>
                </Box>
                <Box component="img" src={Logo} alt="VMS Pro Logo" sx={{ height: 60, width: 300, objectFit: 'contain', mr: 1 }} />
            </Box>

            {isClient ? <ClientDashboardHome /> : <AdminDashboardHome />}
        </Box>
    )
}

export default Dashboard
